import { useState } from 'react'

const ALL_DIRECTIONS = ['nw', 'ne', 'sw', 'se']
const SMALL_SIZE_THRESHOLD = 70
const DEFAULT_SINGLE_DIRECTION = 'sw'
export const MIN_RESIZE_SIZE = 20

export const useDirections = (displayHeight: number, isActive: boolean) => {
  const [activeResizeDir, setActiveResizeDir] = useState<string | null>(null)
  const isSmall = displayHeight <= SMALL_SIZE_THRESHOLD

  const getRenderDirections = (): string[] => {
    if (!isActive) return []
    if (!isSmall) return ALL_DIRECTIONS
    return [activeResizeDir ?? DEFAULT_SINGLE_DIRECTION]
  }

  const directionVectorToKey = (direction: number[]): string => {
    const [x, y] = direction
    if (x === -1 && y === -1) return 'nw'
    if (x === 1 && y === -1) return 'ne'
    if (x === -1 && y === 1) return 'sw'
    return 'se'
  }

  return {
    getRenderDirections,
    directionVectorToKey,
    setActiveResizeDir
  }
}
